import React, { Component, PropTypes } from 'react'
import dateFormat from 'date-fns/format'
import * as GameActions from '../actions/game'
import HighscoreBoard from './HighscoreBoard'
import HighscoreLogContainer from '../containers/HighscoreLogContainer'
require('../styles/modules/highscore.scss');

class Highscore extends Component {
  componentDidMount(){
    this.props.store.dispatch(GameActions.fetchHighscores())
  }

  renderScores(index){
    let challengeId = Object.keys(this.props.highscore).sort(function(a,b){
      return b-a
    })
    if (!challengeId) return
    let scores = this.props.highscore[challengeId[index]] || []
    let selectedIndex
    let result = scores.map((record, recordIndex) => {
      if (record.selected) selectedIndex = recordIndex
      return <tr className={"score" + (record.selected ? " selected" : "")} key={record.name + recordIndex}
                 onClick={this.props.selectHighscore.bind(this, record)}>
               <td>{ record.name }</td>
               <td>{ record.totalMoves }</td>
               <td>{ dateFormat(record.updated_at, 'h:mm:ss a') }</td>
             </tr>
    })
    if(index && result.length){
      let logRecord = <tr key="log"><td colSpan="3"><HighscoreLogContainer {...this.props} data = { scores[selectedIndex] } /></td></tr>
      result.splice(selectedIndex + 1, 0, logRecord)
    }
    return result;
  }

  render() {
    var pastClass = window.innerWidth > 700 ? "flex-box flex-row-reverse justify-content-center" : 0
    return (
      <div className = "highscores">
        <h2>Today's High Scores </h2>
        <table className = "ranking">
          <tbody>
            <tr className = "score">
              <th>Name</th>
              <th>Moves</th>
              <th>Time</th>
            </tr>
            { this.renderScores(0) }
          </tbody>
        </table>
        <h2>Yesterday's High Scores</h2>
        <div className = { pastClass }>
          <div className = "lastBoard">
            <HighscoreBoard { ...this.props } />
          </div>
          <div className = "lastScore">
            <table className = "ranking">
              <tbody>
                <tr>
                  <th>Name</th>
                  <th>Moves</th>
                  <th>Time</th>
                </tr>
                { this.renderScores(1) }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }
}

export default Highscore


// WEBPACK FOOTER //
// ./components/Highscore.js